<template>
  <div style="width: 100%">
    <v-tabs class="special-care-detail-tab">
      <v-tab>
        Chăm sóc đặc biệt
      </v-tab>
      <v-tab-item>
        <SpecialCareDetailTable :item="item" @show-detail="handleShowDetail"></SpecialCareDetailTable>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import SpecialCareDetailTable from '@/modules/student_care/components/SpecialCareDetailTable.vue';

export default {
  name: 'SpecialCareDetail',
  components: { SpecialCareDetailTable },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleShowDetail() {
      this.$emit('show-detail');
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
.special-care-detail-tab {
  .v-tab--active, .v-tabs-slider-wrapper {
    color: #F89234;
  }
}
</style>
